const Bps = {
  xs: `@media (min-width: 350px)`,
  sm: `@media (min-width: 390px)`,
  m: `@media (min-width: 768px)`,
  lg: `@media (min-width: 1024px)`,
  xl: `@media (min-width: 1280px)`,
  xxl: `@media (min-width: 1440px)`,
};
export { Bps };
